module.exports = __webpack_public_path__ + "img/img3.a5bc4173.jpg";